import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IChatMessage } from 'src/interface/IChatState';
import { MessagesContainer } from 'src/styled/Chat/ChatWindow.styled';
import MessageBubble from './MessageBubble';
import TypingIndicator from './TypingIndicator';

interface IMessageListProps {
  messages: IChatMessage[];
  typing?: boolean;
}

export const MessageList: React.FC<IMessageListProps> = ({ messages, typing = false }) => {
  const { t } = useTranslation();
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, typing]);

  return (
    <MessagesContainer>
      {messages.length === 0 && (
        <div style={{ textAlign: 'center', color: '#999', marginTop: '20px' }}>
          {t('chat.welcome')}
        </div>
      )}
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {typing && <TypingIndicator />}
      <div ref={messagesEndRef} />
    </MessagesContainer>
  );
};

export default MessageList;
